import { Validator } from 'vee-validate'

export const validCPF = value => {
  if (!value) return false;

  const cpf = value.replace(/\D/g, ""); // Remove caracteres não numéricos
  if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false;

  let soma = 0, resto;
  for (let i = 1; i <= 9; i++) soma += parseInt(cpf[i - 1]) * (11 - i);
  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(cpf[9])) return false;

  soma = 0;
  for (let i = 1; i <= 10; i++) soma += parseInt(cpf[i - 1]) * (12 - i);
  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;

  return resto === parseInt(cpf[10]);
}

export const validCNPJ = value => {
  if (!value) return false;

  const cnpj = value.replace(/\D/g, ""); // Remove caracteres não numéricos
  if (cnpj.length !== 14 || /^(\d)\1{13}$/.test(cnpj)) return false;

  let tamanho = cnpj.length - 2;
  let numeros = cnpj.substring(0, tamanho);
  let digitos = cnpj.substring(tamanho);
  let soma = 0, pos = tamanho - 7;

  for (let i = tamanho; i >= 1; i--) {
      soma += numeros[tamanho - i] * pos--;
      if (pos < 2) pos = 9;
  }

  let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado !== parseInt(digitos[0])) return false;

  tamanho += 1;
  numeros = cnpj.substring(0, tamanho);
  soma = 0;
  pos = tamanho - 7;

  for (let i = tamanho; i >= 1; i--) {
      soma += numeros[tamanho - i] * pos--;
      if (pos < 2) pos = 9;
  }

  resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);

  return resultado === parseInt(digitos[1]);
}

// CNPJ alfanumérico
export const isValidCnpj = (valor) => {
  var plain = String(valor).replace(/[^0-9A-Za-z]/g, '').toUpperCase();

  if (plain.length !== 14) return false;
  if (/^(.)\1{13}$/.test(plain)) return false;          // todos iguais
  if (!/^[0-9A-Z]{12}[0-9]{2}$/.test(plain)) return false; // DV deve ser numérico

  const digit = (base) => {
      var counter = 2, sum = 0;
      for (var i = base.length - 1; i >= 0; i--) {
          if (counter > 9) counter = 2;
          sum += (base.charCodeAt(i) - 48) * counter;   // era: parseInt(base[i]) * counter
          counter++;
      }
      var rest = sum % 11;
      return (rest < 2) ? 0 : (11 - rest);
  }

  var base = plain.substring(0, 12);
  var dv1 = digit(base);
  var dv2 = digit(base + dv1);

  return plain.charAt(12) === String(dv1) && plain.charAt(13) === String(dv2);
}

export const validVehiclePlate = value => {
  if (!value) return false;

  const placa = value.toUpperCase().replace(/[^A-Z0-9-]/g, ""); // Remove caracteres inválidos
  const regexAntiga = /^[A-Z]{3}-\d{4}$/;  // AAA-9999
  const regexMercosul = /^[A-Z]{3}-\d{1}[A-Z]{1}\d{2}$/; // AAA-9A99

  return regexAntiga.test(placa) || regexMercosul.test(placa);
};

Validator.extend('cpf', {
  getMessage: field => `O ${field} informado é inválido.`,
  validate: validCPF
})

Validator.extend('cnpj', {
  getMessage: field => `O ${field} informado é inválido.`,
  validate: validCNPJ
})

Validator.extend('vehiclePlate', {
  getMessage: field => `A ${field} informada é inválida.`,
  validate: validVehiclePlate
});

Validator.extend('cpf_cnpj', {
  validate(value) {
    const doc = value.replace(/[^A-Za-z0-9]/g, '').toUpperCase();

    return /^\d{11}$/.test(doc) || /^[A-Z0-9]{12}\d{2}$/.test(doc);
  }
});

Validator.extend('cnpj_alphanumeric', {
  validate(value) {
    return isValidCnpj(value);
  }
});
